import { createRequest } from './createRequest'

export const changeEmailPath = '/change-email'
export const changeEmail = createRequest({ path: changeEmailPath })

export const confirmChangeEmailPath = '/confirm-change-email'
export const confirmChangeEmail = createRequest({ path: confirmChangeEmailPath })
